export const removeOccurrences = (string: string, word: string) => {
  const regex = new RegExp(word, 'g');
  return string.replace(regex, '');
};
